<template>
	<div style="flex: 1;padding: 20px;display: flex;flex-direction: column;color:#fff;font-size: 14px;">
		<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
			<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;justify-content: space-between;">
				文件列表
				<div style="display: flex;align-items: center;">
					<span style="margin-right: 10px;">共{{this.list.length}}条数据</span>
					<el-button icon="el-icon-refresh" type="primary" size="small" style="border-radius: 0;" @click="getData">刷新数据</el-button>
				</div>
			</div>
			<div style="padding: 20px;">
				<el-table :data="list" stripe
					style="width: 100%;flex: 1;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;" size="small"
					@selection-change="handleSelectionChange"
					:header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
					:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}" :row-style="{border_color:'rgb(75, 83, 87)'}"
					v-loading="loading">
					<el-table-column label="下载地址"  align="center">
						<template slot-scope="scope">
							<el-link type="primary" icon="el-icon-edit" @click="copy(scope.row.id)">复制 </el-link>
						</template>
					</el-table-column>
					<el-table-column label="备注"  align="center">
						<template slot-scope="scope">
							{{scope.row.one}}
						</template>
					</el-table-column>
				
					<el-table-column label="上传时间"  align="center">
						<template slot-scope="scope">
							{{scope.row.addtime | formatTime}}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="180" align="center">
						<template slot-scope="scope">
							<el-button type="warning" size="mini" @click="toEdit(scope.row)">修改</el-button>
							<el-button type="danger" size="mini" @click="toDelete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data() {
			return {
				loading: false,
				limit: 15,
				total: 0,
				form: {
					card: "",
					card_state: "all",
					card_type: "",
					page: 1,
					software: ''
				},
				list: [],
				multipleSelection: []
			}
		},
		created() {
			this.getData()
		},
		computed: {
			...mapState({
				reload:state=>state.reload
			})
		},
		watch:{
			reload(n,v){
				this.getData()
			}
		},
		filters: {
			formatTime(value) {
				if (value == 0) return ''
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			}
		},
		methods: {
			copy(software_id){
				this.$H.post('verify_center/v1_0_1.Files/Info',{
					file_id:software_id
				}).then(res => {
					console.log(res.data)
					if(!res.data) return;
					let url = res.data.download_prefix+res.data.info.code
					this.$copyText(url).then((e) => {
						this.$message.success('复制成功')
						console.log(e)
					}, (e) => {
						console.log(e)
					})
					console.log(res.data)
				});
				
			},
			search() {
				this.form.page = 1
				this.getData()
			},
			getData() {
				this.loading = true
				this.$H.post('/verify_center/v1_0_1.Files/List', {}).then(res => {
					this.loading = false
					console.log(res.data)
					if (res.data) {
						console.log(res.data)
						this.list = res.data.list
					}
				}).catch(err => {
					this.loading = false
				})
			},
			toDelete(item) {
				this.$confirm('是否删除该文件?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post('/verify_center/v1_0_1.Files/Delete', {
						file_id:item.id
					}).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.getData()
					});
			
				}).catch(() => {
			
				});
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			toPage(val) {
				this.form.page = val
				this.getData()
			},
			toEdit(item){
				this.$emit('toEdit',item.id)
			}
		}
	}
</script>

<style>
	.search input {
		background-color: rgb(75, 83, 87);
		color: #fff;
		border-radius: 0px;

	}

	.el-dialog__header {
		background-color: #409EFF;
		color: #fff;
	}

	.el-dialog__header .el-dialog__title {
		color: #fff;
	}

	.el-dialog__close el-icon el-icon-close {
		color: #fff;
	}

	.footer {
		margin-top: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0;
	}

	.footer .el-pagination__total {
		color: #fff !important;
	}

	.footer input {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
		border-radius: 0;
	}

	.footer>>>.btn-prev {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}

	.el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #909399 !important;
	}
</style>